import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TerceroCargo } from '../../../../_models/tercero-cargo';
import { Nivel } from '../../../../_models/nivel';
import { SelectItem } from 'primeng/api';
import { EstructuraFisica } from '../../../../_models/estructura-fisica';
import { Agrupacion } from '../../../../_models/agrupacion';
import { forkJoin } from 'rxjs';
import { EstructuraFisicaService } from '../../../../_services/estructura-fisica.service';
import { NavService } from '../../../../_services/_nav.service';
import { AgrupacionService } from '../../../../_services/agrupacion.service';
import { AgrupacionOficinaService } from '../../../../_services/agrupacion-oficina.service';
import { AgrupacionOficina } from '../../../../_models/agrupacion-oficina';

@Component( {
  selector: 'app-widget-filtro-prospecto-perfil',
  templateUrl: 'widget-filtro-prospecto-perfil.component.html'
} )

export class WidgetFiltroProspectoPerfilComponent implements OnInit {

  formulario: FormGroup;
  @Input() terCargo: TerceroCargo;
  @Input() nivUsuario: number;
  @Input() widActividad: boolean;
  @Input() widEjecutivo: boolean;
  @Input() widMeses: boolean;
  lisAgrupaciones: SelectItem[] = [];
  lisEstructuraFisica: SelectItem[] = [];
  estFisicaTercero: EstructuraFisica = new EstructuraFisica();
  agrTercero: Agrupacion = new Agrupacion();
  carInformacionTercero = false;
  conCargando = { actividad: false, ejecutivo: false, mes: false };
  oficina: string;
  cargando = false;
  refrescar = false;
  lisAgrupacionOficina: AgrupacionOficina[] = [];
  lisEstructuraFisicaTodas: EstructuraFisica[] = [];

  constructor( private fb: FormBuilder,
               private navServicio: NavService,
               private agrServicio: AgrupacionService,
               private agrOficinaServicio: AgrupacionOficinaService,
               private estFisicaServicio: EstructuraFisicaService ) {
  }

  ngOnInit(): void {
    this.formulario = this.fb.group( {
      idAgrupacion: [ null, [] ],
      idEstructuraFisica: [ null, [] ]
    } );
    this.validarNivel();
  }

  validarNivel() {
    switch ( this.nivUsuario ) {
      case 1:
        this.carInformacionTercero = true;
        break;
      case 2:
      case 3:
        if ( this.terCargo ) {
          this.estFisicaTercero.estructuraFisica = this.terCargo.estructuraFisica;
          this.estFisicaTercero.idEstructuraFisica = this.terCargo.idEstructuraFisica;
          this.oficina = this.terCargo.estructuraFisica;
          this.agrTercero.idAgrupacion = this.terCargo.idAgrupacion;
          this.agrTercero.agrupacion = this.terCargo.agrupacion;
          this.formulario.controls.idEstructuraFisica.setValue( this.terCargo.idEstructuraFisica );
          this.formulario.controls.idAgrupacion.setValue( this.terCargo.idAgrupacion );
        }
        this.carInformacionTercero = true;
        break;
      case 4:
        if ( this.terCargo && (this.terCargo.idAgrupacion !== '' && this.terCargo.idAgrupacion !== null && this.terCargo.idAgrupacion !== undefined) ) {
          this.agrTercero.idAgrupacion = this.terCargo.idAgrupacion;
          this.agrTercero.agrupacion = this.terCargo.agrupacion;
          this.formulario.controls.idAgrupacion.setValue( this.terCargo.idAgrupacion );
          this.estFisicaServicio.obtenerPorAgrupacion( this.terCargo.idAgrupacion ).subscribe( res2 => {
            this.lisEstructuraFisica.push( { label: this.navServicio.buscarMensaje( 'LBL_TODOS' ), value: null } );
            this.oficina = this.navServicio.buscarMensaje( 'LBL_TODOS' );
            res2.map( ( r: EstructuraFisica ) => {
              this.lisEstructuraFisica.push( { label: r.estructuraFisica, value: r.idEstructuraFisica } );
            } );
            this.carInformacionTercero = true;
          } );
        } else {
          this.carInformacionTercero = true;
        }
        break;
      case 5:
        forkJoin( this.estFisicaServicio.getAllEnabled(), this.agrServicio.getAllEnabled(), this.agrOficinaServicio.getAllEnabled() ).subscribe( ( [ res2, lisAgrupaciones, lisAgrupacionOficina ] ) => {
          this.lisAgrupaciones.push( { label: this.navServicio.buscarMensaje( 'LBL_TODOS' ), value: null } );
          this.lisEstructuraFisicaTodas = res2;
          this.cargarTodasEstructuras();
          if( lisAgrupaciones && lisAgrupaciones.length > 0 ) {
            lisAgrupaciones.map( ( r: Agrupacion ) => {
              this.lisAgrupaciones.push( { label: r.agrupacion, value: r.idAgrupacion } );
            } );
          }
          this.lisAgrupacionOficina = lisAgrupacionOficina;
          this.carInformacionTercero = true;
        } );
        break;
      default:
        this.carInformacionTercero = true;
        break;
    }
  }

  cargarBusqueda( valor: boolean, tipo: string ) {
    switch ( tipo ) {
      case 'ACT': {
        this.conCargando.actividad = valor;
        break;
      }
      case 'MES': {
        this.conCargando.mes = valor;
        break;
      }
      case 'EJE': {
        this.conCargando.ejecutivo = valor;
        break;
      }
    }
    this.verificarCargando();
  }

  verificarCargando() {
    setTimeout( () => {
      this.cargando = (this.conCargando.actividad || this.conCargando.mes || this.conCargando.ejecutivo) ? true : false;
      if ( !this.cargando ) {
        this.refrescar = false;
      }
    }, 100 );
  }

  cambioOficina( idOficina: string ) {
    const a = this.lisEstructuraFisica.find( x => x.value == idOficina );
    if ( a ) {
      this.oficina = a.label;
    } else {
      this.oficina = this.navServicio.buscarMensaje( 'LBL_TODOS' );
    }
  }

  cambioAgrupacion( idAgrupacion: string ) {
    this.lisEstructuraFisica = [];
    this.f.idEstructuraFisica.setValue( null );
    if ( idAgrupacion ) {
      this.lisAgrupacionOficina.map( ( s: AgrupacionOficina ) => {
        if ( s.idAgrupacion === idAgrupacion ) {
          this.lisEstructuraFisica.push( { label: s.estructuraFisica, value: s.idEstructuraFisica } );
        }
      } );
    } else {
      this.cargarTodasEstructuras();
    }
  }


  get f() {
    return this.formulario.controls;
  }

  actualizarWidget() {
    this.refrescar = true;
  }

  cargarTodasEstructuras() {
    this.lisEstructuraFisica.push( { label: this.navServicio.buscarMensaje( 'LBL_TODOS' ), value: null } );
    this.lisEstructuraFisicaTodas.map( ( r: EstructuraFisica ) => {
      this.lisEstructuraFisica.push( { label: r.estructuraFisica, value: r.idEstructuraFisica } );
    } );
    this.oficina = this.navServicio.buscarMensaje( 'LBL_TODOS' );
  }

}
